import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import GithubContext from "../../context/github/githubContext";

const UserResultCard = ({ user, insightLogin, onSelectInsight }) => {
  const { login, avatar_url, html_url } = user;
  const { fetchProfileForCard, profilesByLogin } = useContext(GithubContext);

  const profile = profilesByLogin[login];

  useEffect(() => {
    fetchProfileForCard(login);
  }, [login, fetchProfileForCard]);

  const activeInsight = insightLogin === login;

  return (
    <article className={`gf-user-card ${activeInsight ? "gf-user-card--insight" : ""}`}>
      <div className="gf-user-card__top">
        <img
          className="gf-user-card__avatar"
          src={avatar_url}
          alt=""
          width={72}
          height={72}
        />
        <div className="gf-user-card__meta">
          <div className="gf-user-card__title-row">
            <a
              href={html_url}
              target="_blank"
              rel="noopener noreferrer"
              className="gf-user-card__name"
            >
              {profile?.name || login}
            </a>
            <span className="gf-user-card__handle">@{login}</span>
          </div>
          <p className="gf-user-card__loc">
            {profile?.location ? `📍 ${profile.location}` : ""}
          </p>
          <div className="gf-user-card__stats">
            <span title="Followers">
              ⭐ {profile?.followers ?? "—"} followers
            </span>
            <span title="Following">
              👥 {profile?.following ?? "—"} following
            </span>
            <span title="Public repositories">
              📦 {profile?.public_repos ?? "—"} repos
            </span>
          </div>
        </div>
      </div>
      <div className="gf-user-card__actions">
        <button
          type="button"
          className="gf-btn gf-btn--outline gf-btn--sm"
          onClick={() => onSelectInsight(login)}
        >
          Show insights
        </button>
        <Link
          to={`/user/${login}`}
          className="gf-btn gf-btn--primary gf-btn--sm"
        >
          View full profile
        </Link>
      </div>
    </article>
  );
};

export default UserResultCard;
